exports.init = function($) {
  const navInView = elem => {
    return elem.getBoundingClientRect().top > 80;
  }

  const scrollToAnchor = (anchorName, options = {}) => {
    const $target = $(`a[name=${anchorName}]`);

    if ($target.length === 1) {
      const targetOffset = $target.get(0).getBoundingClientRect().top;
      // account for the height of all visible navs
      const visibleTotalNavHeight = $("nav:visible").toArray().reduce((height, elem) => height + (navInView(elem) ? $(elem).height() : 0), 0); 
      const targetY = (window.scrollY || window.pageYOffset) + targetOffset - visibleTotalNavHeight;
      if (options.snap) {
        window.scrollTo(0, targetY);
      } else {
        $("html, body").animate({scrollTop: targetY}, 200);
      }
      return true;
    }

    return false; // didn't find the scroll, or there were too many
  }

  $(".jump-menu").each(function() {
    $(this).find("li a").click(function(e) {
      if ($(this).attr("href").indexOf("#") === 0) {
        if (scrollToAnchor($(this).attr("href").substring(1))) {
          e.preventDefault();
          e.stopPropagation();
          window.location.hash = $(this).attr("href").substring(1);
        }
      }
    })
  });

  // override scrollRestoration where possible, but only modern browsers have this.
  // older browsers may not let us scroll to the hash.
  if (history && history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const hashAnchor = window.location.hash && window.location.hash.substring(1);
  if (hashAnchor) {
      setTimeout(() => scrollToAnchor(hashAnchor, {snap: true}), 100);
  }

  //Scroll Event Category
  const isInViewport = (elem) => {
    const visibleTotalNavHeight = $("nav:visible").toArray().reduce((height, elem) => height + $(elem).height(), 0); 
    const elemY = elem.getBoundingClientRect().y;

    return elemY < visibleTotalNavHeight + 200;
  };

  $(window).on('resize scroll', function() {
    $('.category').each(function () {
      let currentID = $(this).attr('id');
      // console.log(currentID);
      if (isInViewport(this)) {
        $('.active-cat').removeClass('active-cat');
        $(`.menu-content #${currentID}`).addClass('active-cat');
      }
    });
  });

  //Click Event Category
  let myCategories = [];
  $(".menu-content li").each(function () {
    myCategories.push($(this).attr('id'));
    myCategories.forEach((val) => {
      $(`#${val} a`).on('click', function () {
        let parent = $(this).parent();
        if ( $('.cat-menu').hasClass('active-cat') ) {
          $('.cat-menu').removeClass('active-cat');
          parent.toggleClass('active-cat');
        } else {
          parent.toggleClass('active-cat');
        }
      });
    });
  });
}